import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { PaymentDetailComponent } from '@shared/payment-detail/components/payment-detail/payment-detail.component';
import {
  PackagePaymentDetailComponent
} from '@shared/payment-detail/components/package-payment-detail/package-payment-detail.component';
import {
  TotalPaymentDetailComponent
} from '@shared/payment-detail/components/total-payment-detail/total-payment-detail.component';
import {
  HotelPaymentDetailComponent
} from '@shared/payment-detail/components/hotel-payment-detail/hotel-payment-detail.component';
import {
  PaymentDetailLoadingComponent
} from '@shared/payment-detail/components/payment-detail-loading/payment-detail-loading.component';
import { AlertModule } from '@ux/components/alert-message/alert.module';
import { PaymentDetailContComponent } from './payment-detail-cont/payment-detail-cont.component';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { BenefitsModule } from '@shared/benefits/benefits.module';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { AutoPaymentDetailComponent } from '@shared/payment-detail/components/auto-payment-detail/auto-payment-detail.component';
import {
  PaymentRateDiscountComponent
} from '@shared/payment-detail/components/payment-rate-discount/payment-rate-discount.component';
import { PriceDetailCardDsComponent } from '@design-system/components/organisms/price-detail-card/price-detail-card.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { PriceDetailService } from '@shared/payment-detail/services/payment-detail.service';
import { TagMemberDsComponent } from '@design-system/components/molecules/tag-member/tag-member.component';
import { AccordionDsComponent } from '@design-system/components/templates/accordion/accordion.component';

@NgModule({
  declarations: [
    PaymentDetailComponent,
    PackagePaymentDetailComponent,
    TotalPaymentDetailComponent,
    HotelPaymentDetailComponent,
    PaymentDetailLoadingComponent,
    PaymentDetailContComponent,
    AutoPaymentDetailComponent,
    PaymentRateDiscountComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    GlobalPipesModule,
    AlertModule,
    SwipeUpModule,
    BenefitsModule,
    ButtonDsComponent,
    PriceDetailCardDsComponent,
    TypographyDsComponent,
    TagMemberDsComponent,
    AccordionDsComponent,
  ],
  exports: [
    PaymentDetailComponent,
    PackagePaymentDetailComponent,
    TotalPaymentDetailComponent,
    HotelPaymentDetailComponent,
    PaymentDetailLoadingComponent,
    AutoPaymentDetailComponent,
    PaymentDetailContComponent,
    PaymentRateDiscountComponent,
  ],
  providers: [
    PriceDetailService
  ]
})
export class PaymentDetailModule { }
